import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home',
  imports: [CommonModule],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4379 9.10741C15.3133 9.10797 15.192 9.06754 15.0927 8.99237L9.30245 4.65157L3.51217 8.99237C3.39013 9.0839 3.23673 9.1232 3.08571 9.10162C2.93469 9.08005 2.79843 8.99937 2.7069 8.87733C2.61537 8.75529 2.57607 8.60189 2.59764 8.45087C2.61922 8.29985 2.6999 8.16359 2.82194 8.07206L8.95734 3.47051C9.0569 3.39583 9.178 3.35547 9.30245 3.35547C9.42691 3.35547 9.54801 3.39583 9.64757 3.47051L15.783 8.07206C15.8943 8.16251 15.9679 8.29133 15.9892 8.43322C16.0105 8.57511 15.9779 8.71983 15.898 8.83898C15.8491 8.91796 15.7816 8.98374 15.7014 9.03054C15.6212 9.07734 15.5307 9.10374 15.4379 9.10741Z"
        [ngClass]="{
          'fill-black': color === 'black',
          'fill-white': color === 'white'
        }"
      />
      <path
        d="M13.904 15.2428H4.70093C4.54899 15.2408 4.40384 15.1796 4.2964 15.0721C4.18896 14.9647 4.12772 14.8196 4.12573 14.6676V7.38183C4.12573 7.22928 4.18633 7.08298 4.2942 6.97511C4.40207 6.86724 4.54838 6.80664 4.70093 6.80664C4.85348 6.80664 4.99978 6.86724 5.10765 6.97511C5.21552 7.08298 5.27612 7.22928 5.27612 7.38183V14.0924H13.3288V7.38183C13.3288 7.22928 13.3894 7.08298 13.4973 6.97511C13.6052 6.86724 13.7515 6.80664 13.904 6.80664C14.0566 6.80664 14.2029 6.86724 14.3108 6.97511C14.4186 7.08298 14.4792 7.22928 14.4792 7.38183V14.6676C14.4772 14.8196 14.416 14.9647 14.3086 15.0721C14.2011 15.1796 14.056 15.2408 13.904 15.2428Z"
        [ngClass]="{
          'fill-black': color === 'black',
          'fill-white': color === 'white'
        }"
      />
      <path
        d="M10.8363 15.243C10.6844 15.241 10.5392 15.1798 10.4318 15.0723C10.3243 14.9649 10.2631 14.8197 10.2611 14.6678V9.87451H8.34381V14.6678C8.34381 14.8203 8.28321 14.9666 8.17534 15.0745C8.06747 15.1824 7.92117 15.243 7.76861 15.243C7.61606 15.243 7.46976 15.1824 7.36189 15.0745C7.25402 14.9666 7.19342 14.8203 7.19342 14.6678V9.29931C7.19541 9.14738 7.25665 9.00223 7.36409 8.89479C7.47153 8.78735 7.61668 8.72611 7.76861 8.72412H10.8363C10.9882 8.72611 11.1334 8.78735 11.2408 8.89479C11.3483 9.00223 11.4095 9.14738 11.4115 9.29931V14.6678C11.4095 14.8197 11.3483 14.9649 11.2408 15.0723C11.1334 15.1798 10.9882 15.241 10.8363 15.243Z"
        [ngClass]="{
          'fill-black': color === 'black',
          'fill-white': color === 'white'
        }"
      />
    </svg>
  `
})
export class HomeComponent {
  @Input() color = 'black';
}
